import React from 'react';
import style from './style.scss';

const TabHead: React.SFC<{}> = ({ children }) => <ul className={style.tabHead}>{children}</ul>;

export default TabHead;
